import {createFileRoute} from "@tanstack/react-router";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/adgpt/playground",
)({
    loader: ({context}) => ({workspaceId: context.workspace.id}),
    component: RouteComponent,
});
